import React from 'react';
import clsx from 'clsx';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme) => ({
  buttonWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  fullWidth: {
    width: '100%',
  },
  buttonProgress: {
    color: 'primary',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
    marginTop: -12,
  },
});

class AsyncActionButton extends React.Component {
  render() {
    const {
      classes,
      loading,
      action,
      className,
      startIcon,
      variant,
      fullWidth,
      color,
      size,
      style,
      disabled,
    } = this.props;

    return (
      <div
        className={classNames(
          classes.buttonWrapper,
          fullWidth && classes.fullWidth,
        )}
      >
        <Button
          startIcon={startIcon}
          size={size}
          color={color}
          variant={variant}
          fullWidth={fullWidth}
          className={clsx(classes.button, className)}
          style={style}
          disabled={loading || disabled}
          onClick={action}
        >
          {this.props.children}
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </div>
    );
  }
}

AsyncActionButton.defaultProps = {
  variant: 'contained',
  fullWidth: false,
  color: 'primary',
  size: 'large',
};

AsyncActionButton = withStyles(styles)(AsyncActionButton);
AsyncActionButton.propTypes = {
  loading: PropTypes.bool,
  action: PropTypes.func.isRequired,
};

export default AsyncActionButton;
